import PropTypes from 'prop-types';

export const Breakdown = PropTypes.shape({
  hardMeter: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  in: PropTypes.string.isRequired,
  paid: PropTypes.string.isRequired,
  net: PropTypes.string.isRequired,
  tax: PropTypes.string.isRequired
});

export const Totals = PropTypes.shape({
  in: PropTypes.string.isRequired,
  paid: PropTypes.string.isRequired,
  net: PropTypes.string.isRequired,
  tax: PropTypes.string.isRequired
});

export const Receiver = PropTypes.shape({
  receiver: PropTypes.string,
  identifier: PropTypes.string,
  net: PropTypes.string.isRequired,
  tax: PropTypes.string.isRequired
});

export const Summary = PropTypes.shape({
  receivers: PropTypes.arrayOf(
    Receiver.isRequired
  ).isRequired,
  totalTax: PropTypes.string.isRequired
});

export const Report = PropTypes.shape({
  location: PropTypes.string,
  locationPhone: PropTypes.string,
  locationAddress: PropTypes.string,
  locationGOA: PropTypes.string.isRequired,
  route: PropTypes.string,
  routePhone: PropTypes.string,
  routeMDR: PropTypes.string,
  quarter: PropTypes.string,
  endOfQuarter: PropTypes.string,
  dateRange: PropTypes.string,
  title: PropTypes.string,
  summary: Summary.isRequired,
  breakdown: PropTypes.arrayOf(
    Breakdown.isRequired
  ),
  totals: Totals.isRequired
});


// WEBPACK FOOTER //
// ./src/shapes/report.js